import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from '../core/loading-spinner/loading.service';
import { SessionService } from './session.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  totalRequests = 0;
  completedRequests = 0;

  constructor(
    private router: Router,
    private readonly loadingService: LoadingService,
    private readonly sessionService: SessionService
  ) {}

  private clearAuthCookies(): void {
    // Clear auth cookies by setting them to expire in the past
    const cookiesToClear = ['Authentication', 'Refresh', 'AuthenticationAdmin'];
    cookiesToClear.forEach(name => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });
    this.sessionService.setUser(null);
  }

  private isServerUnavailable(err: HttpErrorResponse): boolean {
    // Network error (no connection) or server errors (502, 503, 504)
    return (
      err.status === 0 ||
      err.status === 502 ||
      err.status === 503 ||
      err.status === 504
    );
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    request = request.clone({
      withCredentials: true,
    });
    this.loadingService.show(request);
    this.totalRequests++;
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<unknown>) => {
          if (event instanceof HttpResponse) {
          }
        },
        (err: unknown) => {
          if (err instanceof HttpErrorResponse) {
            // Handle server unavailable (network error, 502, 503, 504)
            if (this.isServerUnavailable(err)) {
              this.clearAuthCookies();
              this.sessionService.setServiceUnavailable(true);
              this.router.navigate(['login']);
              return;
            }

            if (err.status === 401 && !this.sessionService.isIgnore401()) {
              this.clearAuthCookies();
              this.router.navigate(['login']);
            }
            // Handle 404 "User not found" on auth endpoints - invalid/stale JWT
            if (err.status === 404 && request.url.includes('/auth/jwt/')) {
              this.clearAuthCookies();
              this.router.navigate(['login']);
            }
          }
        }
      ),
      finalize(() => {
        this.completedRequests++;
        // console.log(this.completedRequests, this.totalRequests);
        if (this.completedRequests === this.totalRequests) {
          this.loadingService.hide();
          this.completedRequests = 0;
          this.totalRequests = 0;
        }
      })
    );
  }
}
